angular.module('app.entity.audit', [
    'app.entity.service',
    'gettext',
    'inetsys.conditions',
    'sharecrf-files',
]);

